// extracted by mini-css-extract-plugin
export default {"card":"styles_card__MZ9c6","img":"styles_img__7u24+","desc":"styles_desc__onGl2"};